var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * SocialYoutube icon component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconSocialYoutube extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.5 7.17857C1.5 5.69924 2.69924 4.5 4.17857 4.5H19.6071C21.0865 4.5 22.2857 5.69924 22.2857 7.17857V17.4643C22.2857 18.9436 21.0865 20.1429 19.6071 20.1429H4.17857C2.69924 20.1429 1.5 18.9436 1.5 17.4643V7.17857ZM4.17857 3C1.87081 3 0 4.87081 0 7.17857V17.4643C0 19.772 1.87081 21.6429 4.17857 21.6429H19.6071C21.9149 21.6429 23.7857 19.772 23.7857 17.4643V7.17857C23.7857 4.87081 21.9149 3 19.6071 3H4.17857ZM15.7208 12.707L9.74541 16.1926V9.22132L15.7208 12.707ZM9.70168 7.66067C9.44375 7.65375 9.18881 7.71733 8.96432 7.84454C8.73982 7.97175 8.55428 8.15778 8.42766 8.38261C8.30318 8.60364 8.24028 8.85393 8.24541 9.10738V16.2956C8.24384 16.5474 8.3085 16.7951 8.43292 17.014C8.558 17.2341 8.73904 17.4172 8.95768 17.5447C9.17631 17.6722 9.42479 17.7397 9.67791 17.7403C9.93104 17.7408 10.1798 17.6745 10.399 17.5479L16.5733 13.9462L16.575 13.9453C16.7908 13.8186 16.9699 13.6377 17.0943 13.4205C17.2187 13.2032 17.2841 12.9573 17.2841 12.707C17.2841 12.4567 17.2187 12.2107 17.0943 11.9935C16.9699 11.7763 16.7908 11.5953 16.575 11.4687L10.4127 7.87402C10.1989 7.74111 9.95354 7.66741 9.70168 7.66067ZM8.24541 9.10738V9.0984L8.24573 9.12046L8.24541 9.10738Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconSocialYoutube.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconSocialYoutube.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconSocialYoutube.prototype, "size", void 0);
if (customElements.get('cat-icon-social-youtube') === undefined) {
    customElements.define('cat-icon-social-youtube', BlocksIconSocialYoutube);
}
